import React from 'react'
import { motion } from "framer-motion";
import BackGround from '../BackGround';
import Home from './Home';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Social from '../Social';

function MainHome() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
      }}
    >
      <Home />
      <Social />


      {!isMobile && <BackGround />}
    </motion.main>
  )
}

export default MainHome;